import React, { Component } from 'react'
import { Container, Row, Col, Image, Card } from 'react-bootstrap'
import AsideNavbar from '../components/navbars/AsideNavbar'
import StudentHomeSection from '../components/home/StudentHomeSection'
import HomeNavbar from '../components/home/HomeNavbar';
import DummyHomeNavbar from '../components/home/DummyHomeNavbar';
import * as Cookies from "es-cookie";
import Navbars from '../components/navbars/Navbars';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";
import PreloaderTwo from '../components/preloader/PreloaderTwo';
import PreloaderFour from '../components/preloader/PreloaderFour';
import EamcetHome from '../components/home/EamcetHome';
import ContentLoader from 'react-content-loader';

import ReactGA from 'react-ga';
import { GoogleAnalyticsArray } from './GoogleAnalytics';
import { tokenChecking } from './GlobalFunctions';
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";



const FETCH_GET_SUBJECTS = gql`
  query ($mobile: String) {
    getSubjects(mobile: $mobile) {
      id
      subject
      practice_percentage
      studentChapters {
        id
        chapter
        topics {
          id
          topic
        }
        class
        attempted_questions
        practice_wrong_answered
        error_questions
        accuracy
        videoAccess
        chapterPreviousquestionsAccess
        enabled
        linkAnalyEnabled
        customExamsEnabled
        errorExamsEnabled
        revMatrialEnabled
        total_questions
      }
    }
  }
`;

const UPDATE_STUDENT_ANALYTICS = gql`
  mutation(
    $params:AnalyticsStudents1  
    ) {
        studentAnalytics(
        params: $params
     )
  }
`;

const SUBMIT_SCHEDULE_TEST = gql`
  mutation(
    $params:FinishStudentScheduleExam ,$uid:String 
    ) {
        finishStudentScheduleExam(
        params: $params,
        uid:$uid
     )
  }
`;

class StudentHome extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headerBottomImg: {
                type: "homePage",
                title: Cookies.get("examid") == 3 ? "AP EAPCET (MPC)" : Cookies.get("examid") == 6 ? "TS EAMCET (MPC)" : Cookies.get("examid") == 7 ? "AP EAPCET (BiPC)" : Cookies.get("examid") == 8 ? "TS EAMCET (BiPC)" : Cookies.get("examid") == 9 ? "KCET (MBiPC)" : Cookies.get("examid") == 10 ? "KCET (MPC)" : "KCET (BiPC)"
            },
            mainindex: 0,
            getSubjects: [],

            toggled: isMobile == true && Cookies.get("institution_id") == 30 ? "wrapper" : Cookies.get("toggle"),
            submitError: "",
        }
    }


    menuToggler = () => {
        const toggled = this.state.toggled;
        if (toggled === "wrapper") {
            this.setState({ toggled: "wrapper sidebar-enable" });
            Cookies.set("toggle", "wrapper sidebar-enable");
        } else {
            this.setState({ toggled: "wrapper" });
            Cookies.set("toggle", "wrapper");
        }
    };

    componentDidMount = () => {
        // OFFLINE FUNCTIONALITY DISABLED
        // this.syncOfflineData();
        // window.addEventListener('online', this.syncOfflineData);
        this.addStudentAnalytics();

        let title = "";
        if (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) {
            title = GoogleAnalyticsArray[0].Eamcet_Home;
            ReactGA.pageview('/student/home', title);
        }
        if (Cookies.get("examid") == 1 || Cookies.get("examid") == 2) {
            title = GoogleAnalyticsArray[0].Home;
            ReactGA.pageview('/student/home', title);
        }

        const subjects = this.props.getSubjects?.getSubjects;
        if (subjects && !this.props.getSubjects?.loading) {
            this._loadSubjectsFromData(subjects);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.getSubjects?.loading && !this.props.getSubjects?.loading) {
            const subjects = this.props.getSubjects?.getSubjects;
            if (subjects) {
                this._loadSubjectsFromData(subjects);
            }
        }
    }

    _loadSubjectsFromData = (subjects) => {
        localStorage.setItem("globalsubjects", JSON.stringify(subjects));
        const getSubjects = subjects.map((gmap, index) => ({
            ...gmap,
            active: index === 0 ? "active" : ""
        }));
        this.setState({ getSubjects });
    }

    componentWillUnmount() {
        // window.removeEventListener('online', this.syncOfflineData);
    }

    addStudentAnalytics = e => {
        let addStudentObj = ""

        if (Cookies.get("examid") == 1 || Cookies.get("examid") == 2) {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 4,
                source: 2
            }
        } else if (Cookies.get("examid") == 3 || Cookies.get("examid") == 6 || Cookies.get("examid") == 7 || Cookies.get("examid") == 8) {
            addStudentObj = {
                exam_id: parseInt(Cookies.get("examid")),
                mobile: Cookies.get("mobile"),
                analytics_module_page_id: 104,
                source: 2
            }
        }


        this.submitpt(
            addStudentObj
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
        });
    }

    submitpt = async (
        params) => {
        await this.props.submitpt({
            variables: {
                params
            },
        });
    };

    // OFFLINE FUNCTIONALITY DISABLED
    // syncOfflineData = () => {
    //     if (!navigator.onLine) return;
    //     const offlineSubmission = localStorage.getItem("offline_submission");
    //     if (offlineSubmission) {
    //         try {
    //             const { params, uid } = JSON.parse(offlineSubmission);
    //             this.props.finishStudentScheduleExam({
    //                 variables: {
    //                     params,
    //                     uid
    //                 }
    //             }).then(({ data }) => {
    //                 if (data && data.finishStudentScheduleExam) {
    //                     localStorage.removeItem("offline_submission");
    //                     alert("Offline exam submission successful. Your results are being processed.");
    //                 }
    //             }).catch(err => {
    //                 console.error("Sync failed", err);
    //             });
    //         } catch (e) {
    //             console.error("Error parsing offline submission", e);
    //         }
    //     }
    // }

    handleSelect = (subid) => {
        const getSubjects = this.state.getSubjects.map((gmap, index) => {
            if (index == subid) {
                return { ...gmap, active: "active" }
            }
            else {
                return { ...gmap, active: "" }
            }
        })
        this.setState({
            getSubjects: getSubjects,
            mainindex: subid
        });
    }

    render() {
        if (Cookies.get("studenttoken") == undefined)
            this.props.history.push("/student/login");

        let isStudentUserValid = "";
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
        else {
            this.props.history.push("/student/login");
        }



        if (isStudentUserValid.isStudentUserValid != undefined) {
            if (isStudentUserValid.isStudentUserValid.estatus == 0) {
                Cookies.remove("token");
                Cookies.remove("username");
                Cookies.remove("refreshtoken");
                Cookies.remove("email");
                Cookies.remove("id");
                Cookies.remove("institutionid");
                Cookies.remove("userlevel");
                Cookies.remove("name");
                this.props.history.push("/student/login");
            }
            localStorage.removeItem('isStudentUserValid');
            localStorage.setItem(
                "isStudentUserValid",
                JSON.stringify(isStudentUserValid.isStudentUserValid)
            );
        }

        let studentGlobals = "";
        if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
            studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
        }
        else {
            this.props.history.push("/student/login");
        }

        if (this.state.getSubjects.length
            > 0) {
            return (
                <div className={this.state.toggled}>
                    <div className="student main-wrapper">
                        <div className="student header-area">
                            {
                                (Cookies.get("examid") == 1 || Cookies.get("examid") == 2) ?
                                    (

                                        <>
                                            {
                                                <HomeNavbar
                                                    stateData={this.state}
                                                    getSubjects={this.state.getSubjects}
                                                    onClick={() => this.menuToggler()}
                                                    logout={this.props.logout}
                                                    studentGlobals={studentGlobals}
                                                    pageType={"referalfriendimage"} />
                                            }
                                        </>


                                    )
                                    :
                                    (

                                        <Navbars onClick={() => this.menuToggler()} headerBottom={this.state.headerBottomImg} />

                                    )
                            }
                        </div>
                        {/* {Cookies.get("institution_id") != "30" ? (loading5 == true) && (<PreloaderTwo />) : ""} */}
                        <AsideNavbar onClick={() => this.menuToggler()} />
                        <div className="student-overlay" onClick={() => this.menuToggler()} />
                        <div className="content-wrapper pt-0">
                            <Container>
                                {(Cookies.get("examid") == 1 || Cookies.get("examid") == 2) ? (

                                    <StudentHomeSection
                                        stateData={this.state}
                                        studentGlobals={studentGlobals}
                                        getSubjects={this.state.getSubjects}
                                        handleSelect={this.handleSelect}
                                        isStudentUserValid={isStudentUserValid} />
                                ) : (



                                    <EamcetHome
                                        stateData={this.state}
                                        studentGlobals={studentGlobals}
                                        isStudentUserValid={isStudentUserValid}
                                    />


                                )
                                }
                            </Container>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className={this.state.toggled}>
                <div className="student main-wrapper">
                    <div className="student header-area">
                        <DummyHomeNavbar onClick={() => this.menuToggler()} />
                    </div>
                    {/* Real side menu while the home data loads: it reads restrictions from storage, not from getSubjects. */}
                    <AsideNavbar onClick={() => this.menuToggler()} />
                    <div className="student-overlay" onClick={() => this.menuToggler()} />
                    <div className="content-wrapper pt-0">
                        <Container>
                            <section className="student-home">
                                <Row className="student-subject-card">
                                    {[1, 2, 3, 4].map((n) => (
                                        <Col key={n} xl={3} lg={3} md={6} sm={12}>
                                            <Card className="single-card shadow-sm border-0">
                                                <Card.Body className="p-2">
                                                    <ContentLoader viewBox="0 0 500 175" height={175} width="100%" speed={2}>
                                                        <rect x="30" y="30" rx="10" ry="10" width="70" height="70" />
                                                        <rect x="129.9" y="29.5" width="125.5" height="17" />
                                                        <rect x="129.9" y="64.7" width="296" height="17" />
                                                        <rect x="129.9" y="97.8" width="253.5" height="17" />
                                                        <rect x="129.9" y="132.3" width="212.5" height="17" />
                                                    </ContentLoader>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                                <Row>
                                    {[1, 2, 3].map((n) => (
                                        <Col key={n} xl={4} lg={4} md={12} sm={12}>
                                            <Card className="my-3 border-0">
                                                <div className="showcase-component">
                                                    <ContentLoader speed={2} width={400} height={560} viewBox="0 0 420 560" backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
                                                        <rect x="8" y="14" rx="2" ry="2" width="400" height="560" />
                                                    </ContentLoader>
                                                </div>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            </section>
                        </Container>
                    </div>
                </div>
            </div>
        );

    }
}


export default withRouter(compose(
    graphql(FETCH_GET_SUBJECTS, {
        options: () => ({
            variables: { mobile: Cookies.get("mobile") },
            fetchPolicy: "no-cache",
        }),
        name: "getSubjects",
    }),
    graphql(UPDATE_STUDENT_ANALYTICS, {
        name: "submitpt"
    }),
    graphql(SUBMIT_SCHEDULE_TEST, {
        name: "finishStudentScheduleExam"
    }),
)(StudentHome));
